import React, { useState } from "react";
import FormContext from "./formContext";

const FormState = ({ children }) => {
  const [subjects, setSubjects] = useState("");
  const [stateArr, setStateArr] = useState([]);
  const [loginObj, setLoginObj] = useState({});
  const [previewlink, setPreviewlink] = useState("");
  const [showform, setShowform] = useState(false);

  // newcode
  const [backward, setbackward] = useState(false);
  const [editable, setEditable] = useState(true);
  const [initial,setInitial]=useState(false);

  const stateList = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Cookie",
      "AWSALB=UEefCEQ/bZdxKzLAWXtBfat6dPx2vHb68oIiOpHEBDkxbGk6lhWD3Os1kyPh5Fxq5c3dlkSOjwRrPkR9DpwN713M5wu/+zXvy0fObz92ohC2hCP14I7PyRQOA79S; AWSALBCORS=UEefCEQ/bZdxKzLAWXtBfat6dPx2vHb68oIiOpHEBDkxbGk6lhWD3Os1kyPh5Fxq5c3dlkSOjwRrPkR9DpwN713M5wu/+zXvy0fObz92ohC2hCP14I7PyRQOA79S"
    );

    var raw = JSON.stringify({
      dbname: "erp_eshiksa",
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch("https://erpapi.eshiksa.net/SihfwGnm/State.php", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        var responseObj = JSON.parse(result);

        setStateArr(responseObj.data);
      })
      .catch((error) => console.log("error", error));
  };

  return (
    <FormContext.Provider
      value={{
        subjects,
        setSubjects,
        stateArr,
        setStateArr,
        loginObj,
        setLoginObj,
        stateList,
        previewlink,
        setPreviewlink,
        showform,
        setShowform,
        backward,
        setbackward,
        editable,
        setEditable,
        initial,setInitial
      
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export default FormState;
